export default __webpack_public_path__ + "4cbe3fefc428792c4701831544f25090.png";